import { render, staticRenderFns } from "./m-notification.vue?vue&type=template&id=3c0ce9d0&scoped=true"
import script from "./m-notification.vue?vue&type=script&lang=js"
export * from "./m-notification.vue?vue&type=script&lang=js"
import style0 from "./m-notification.vue?vue&type=style&index=0&id=3c0ce9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ce9d0",
  null
  
)

export default component.exports